import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../clients';
import { refreshTurnSchema } from '../types';

export const receiveRefresh = createReceive('refresh', zodContract(refreshTurnSchema));
